﻿export class DataRequest {
    $type: string;
}
